import React from 'react';

import C from '../C';

import DataStore from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
// import ChartWidget from './ChartWidget';
import AdvertiserTrafficReport from './AdvertiserTrafficReport';

/**
 * TODO currently this is per-advert -- we'd prefer per-advertiser
 */
function AdvertiserDashPage() {
	let path = DataStore.getValue('location', 'path');
	let vertiserId = path[1];

	//special page if user navigates directly to route /#vertdash/ (no args)
	if (!vertiserId) {
		return (
			<div>
				<h1> You&#39;re not supposed to be here </h1>
				<p>Please ensure that the URL you have entered is correct. These should follow the format good-loop.com/#vertdash/advertiser-id</p>
			</div>
		);
	}

	let advertData = ActionMan.getDataItem({type:C.TYPES.Advert, id:vertiserId, status:C.KStatus.DRAFT});
	const pubReadableName = advertData && advertData.value && advertData.value.name ? advertData.value.name : vertiserId;

	// display...
	return (
		<div className="page AdvertiserDashPage">
			<h1>Traffic report for {pubReadableName}</h1>
			<AdvertiserTrafficReport />
		</div>
	);
} // ./DashboardPage

export default AdvertiserDashPage;
